<template>
  <div class="rounded bg-grey_3 pa-3 my-3 bordered" v-if="option.visible_accueil == '1'">
    <div class="d-flex justify-space-between gap">
      <div>
        <h5 class="font-weight-bold">
          {{ option.nom }}
        </h5>
        <div v-if="option.list_liaisons_course.length > 0 || option.list_liaisons_pack.length > 0">
          <div>Disponible pour les participants:</div>
          <div class="d-flex flex-wrap justify-start align-center sm-gap mb-1">
            <div class="text-body-2 bg-white px-2 py-1 rounded shadowed"
              v-for="liaison_course in option.list_liaisons_course" :key="liaison_course.id">
              <v-icon icon="mdi-check" color="primary" size="xs-small"></v-icon> {{ liaison_course.nom_course }}
            </div>
            <div class="text-body-2 bg-white px-2 py-1 rounded shadowed"
              v-for="liaison_course in option.list_liaisons_pack" :key="liaison_course.id">
              <v-icon icon="mdi-check" color="primary" size="xs-small"></v-icon> Pack {{ liaison_course.nom_pack }}
            </div>
          </div>
        </div>
        <div v-else>
          <div>Ouvert à tous</div>
        </div>

        <div v-if="option.information_supplementaire != ''">
          <div class="text-body-1" v-html="option.information_supplementaire"></div>
        </div>
        <div v-if="$moment(option.date_min).isValid()">Ouverture des inscriptions: {{ $moment(option.date_min + " " +
          option.heure_min).format("DD/MM/YYYY à HH:mm") }}</div>
        <div v-if="$moment(option.date_max).isValid()">Fermeture des inscriptions: {{ $moment(option.date_max + " " +
          option.heure_max).format("DD/MM/YYYY à HH:mm") }}</div>

        <div class="text-body-2" v-for="variante in variantes_tarifs" :key="variante.id">
          <span v-if="variante.information_variante_tarif != ''">- {{ variante.information_variante_tarif }} ({{
            variante.prix }}€)</span>
          <!-- <span v-if="variante.quantite == '0'">{{ variante.nb_inscrits }} participant(s)</span> -->
          <span v-else-if="variante.quantite != '0' && parseInt(variante.quantite) > parseInt(variante.nb_inscrits)"> :
            {{
              variante.nb_inscrits }}/{{ variante.quantite }} participant(s)</span>
          <span v-else-if="variante.quantite != '0' && parseInt(variante.quantite) <= parseInt(variante.nb_inscrits)"> :
            Complet</span>
        </div>
      </div>

      <div class="d-flex flex-column justify-center align-end">
        <div v-if="mainStore.billetterie_mode">
          <v-btn class="inscription_btn shadowed" v-if="show_button_inscription" color="dark-green" size="default"
            variant="tonal" @click="$router.push({ name: 'Inscriptions' })"><v-icon icon="mdi-arrow-right-bold"
              class="mr-2"></v-icon> Réserver</v-btn>
          <v-btn v-else class="shadowed" color="dark-red" size="small" variant="tonal"><v-icon
              icon="mdi-pencil-off-outline"></v-icon> Inscriptions closes</v-btn>
        </div>
        <div v-if="!mainStore.billetterie_mode && option.has_bouton_renvoi_billetterie()">
          <v-btn class="inscription_btn shadowed" v-if="show_button_inscription" color="dark-green" size="default"
            variant="tonal" @click="redirect_to_billetterie()"><v-icon icon="mdi-arrow-right-bold"
              class="mr-2"></v-icon> Réserver l'option seule</v-btn>
        </div>
        <TarifsOption :base="option.prix" :metadatas="option.metadatas"></TarifsOption>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import TarifsOption from "@/components/Home/Options/Tarifs_Option.vue";
export default {
  props: ["option", "all_options"],
  components: { TarifsOption },
  computed: {
    ...mapStores(useMainStore),
    show_button_inscription() {
      const selectionnable = this.option.is_selectionnable(this.mainStore.module.status, this.mainStore.view_as_admin, this.mainStore.inscription_as_admin, this.mainStore.inscription_vip)
      return selectionnable;
    },
    variantes_tarifs() {
      let variantes = [];
      for (let i = 0; i < this.all_options.length; i++) {
        if (this.all_options[i].nom == this.option.nom) {
          variantes.push(this.all_options[i]);
        }
      }
      return variantes;
    },
  },
  methods: {
    redirect_to_billetterie() {

      this.mainStore.billetterie_mode = true;
      this.$router.push({ name: "Inscriptions", params: { base_module: "BILLETTERIE_" + this.mainStore.module.base } });
    }
  },
};
</script>

<style lang="scss" scoped></style>